import BaseSettingHandler from './BaseSettingHandler';

/**
 * ShHtmlMuti
 */
export class ShHtmlMuti extends BaseSettingHandler {
  /**
   * read
   * @param options options
   * @returns
   */
  read(options: { $atom: JQuery; $activePanel: JQuery }) {
    if (!this.setting.targetSelectors) {
      alert(`Thiếu targetSelectors: ${this.setting.name}`);
    } else {
      let value = '';
      for (let i = 0; i < this.setting.targetSelectors.length; i++) {
        const targetSelector = this.setting.targetSelectors[i];
        const $target = options.$atom.find(targetSelector);
        if ($target && $target.length) {
          value = $target.html();
          if (value) {
            break;
          }
        }
      }
      if (!value) {
        value = this.setting.default_value || '';
      }

      options.$activePanel
        .find(`[name="${this.setting.name}"]`)
        .attr('value', value)
        .val(value)
        .trigger('value-change');
      return { value: value };
    }
  }

  /**
   * write
   * @param value value
   * @param options options
   */
  write(
    value: any,
    options: {
      $atom: JQuery;
    },
  ): {
    refreshType: string;
    style?: string | undefined;
  } {
    if (!this.setting.targetSelectors) {
      alert(`Thiếu targetSelectors: ${this.setting.name}`);
    } else {
      for (let i = 0; i < this.setting.targetSelectors.length; i++) {
        const targetSelector = this.setting.targetSelectors[i];
        const $target = options.$atom.find(targetSelector);
        if ($target && $target.length) {
          $target.html(value);
          return {
            refreshType: 'css',
          };
        }
      }
    }
    return {
      refreshType: 'css',
    };
  }
}
